/* global flatpickr createElementToast */
const serviceSearchBox = {
	el: {
		formContainer: document.querySelector('.js-searchbox-form'),
		groupContainer: document.querySelectorAll('.js-searchbox-detect-click-outside'),
		toggleModal: document.querySelectorAll('.js-searchbox-toggle-modal'),
		tabs: document.querySelectorAll('.js-searchbox-tab'),
		selectedItem: document.querySelectorAll('.js-searchbox-select-item'),
		counterButton: document.querySelectorAll('.js-searchbox-counter-button'),
		counterValue: document.querySelector('.js-searchbox-counter-value'),
		counterLabelValue: document.querySelector('.js-searchbox-counter-label-value'),
		inputCheckIn: document.querySelector('.js-searchbox-check-in'),
		inputCheckOut: document.querySelector('.js-searchbox-check-out'),
		flatPickerContainer: document.querySelectorAll('.js-searchbox-date-picker'),
		promoValue: document.querySelector('.js-searchbox-promocode-value')
	},

	vars: {
		currentNumberOfGuests: 0
	},

	fxHandleCounter(el) {
		// get attribute that define if button is for increase or decrease counter
		const buttonClicked = el.currentTarget.getAttribute('data-searchbox-counter')

		// if button has attribute increase, we increment on our variable, if not we subtract it
		if (buttonClicked === 'increase') {
			this.vars.currentNumberOfGuests += 1
		}
		else {
			// this if is for make sure that number does not go below zero
			if (this.vars.currentNumberOfGuests === 0) return
			this.vars.currentNumberOfGuests -= 1
		}

		// This condition is for label inside container, we hide it if number of guests is different than zero
		if (this.vars.currentNumberOfGuests != 0) {
			// Add class on parentNode in order to hide label and indicate only new value
			el.currentTarget.closest('.searchbox__control-group').classList.add('updated')
		}
		else {
			el.currentTarget.closest('.searchbox__control-group').classList.remove('updated')
		}

		// set text content on our modal with variable that has been increased or subtracted
		this.el.counterValue.textContent = this.vars.currentNumberOfGuests

		// set value on input with variable that has been increased or subtracted
		this.el.counterLabelValue.value = this.vars.currentNumberOfGuests || ''
	},

	fxHandlePromoCode(event) {
		// This condition is for label inside container, we hide it if the input if filled.
		if (event.currentTarget.value != '' || document.activeElement === event.currentTarget) {
			// Add class on parentNode in order to hide label and indicate only new value
			event.currentTarget.closest('.searchbox__control-group').classList.add('updated')
		}
		else {
			event.currentTarget.closest('.searchbox__control-group').classList.remove('updated')
		}
	},

	fxSwitchTabs(el) {
		// General function that resets all form - show labels and reset counter
		this.fxResetSearchBox()

		// remove all active classes from any tab
		this.el.tabs.forEach(el => el.classList.remove('active'))

		// add active class to current target
		el.currentTarget.classList.add('active')
	},

	fxSwitchSelectListOnceClicked(el) {
		// get attribute to detect witch tab has been clicked
		const searchBoxTab = el.currentTarget.getAttribute('data-searchbox-tab')

		// check if has element
		if (!document.querySelector(`.searchbox-select__list--${searchBoxTab}`)) return

		// remove all show classes from any container
		document.querySelectorAll('.searchbox-select__list').forEach(el => el.classList.remove('show'))

		// find container that has class that ends with data attribute of clicked tab and add class show
		document.querySelector(`.searchbox-select__list--${searchBoxTab}`).classList.add('show')
	},

	fxToggleModalSearchBox(el) {
		// check if current target of click has class focused, if yes, just remove it, if not, add it
		if (el.currentTarget.parentNode.classList.contains('focused')) {
			el.currentTarget.parentNode.classList.remove('focused')
		}
		else {
			this.el.toggleModal.forEach(el => el.parentNode.classList.remove('focused'))
			el.currentTarget.parentNode.classList.add('focused')
		}
	},

	fxAddSelectValueToForm(el) {
		// save value of selected item
		const valueOfItemSelected = el.currentTarget.textContent
		const codeOfItemSelected = el.currentTarget.getAttribute('data-option-code')

		// first we find parent focused class and add updated class in order to hide label from container
		el.currentTarget.closest('.focused').classList.add('updated')

		// remove class focused - responsible for close modal after select any item
		el.currentTarget.closest('.focused').classList.remove('focused')

		// update text on container that shows item selected
		document.querySelector('.js-searchbox-select-value').textContent = valueOfItemSelected

		// update value on input select
		document.querySelector('.js-searchbox-select-tag').value = codeOfItemSelected
	},

	fxInitFlatpickr(el) {
		// save in a variable options of flatpickr
		const flatpickrOptions = {
			locale: el.dataset.language,
			// this mode enable user to choose two dates, check in and check out
			mode: 'range',
			// minDate is the minimum date that can be selected
			minDate: 'today',
			// inline is for display date in the same line with input
			inline: true,
			dateFormat: 'Y-m-d',

			// onValueUpdate is a callback that is called when the user changes the date
			onValueUpdate: selectedDates => {

				// get date selected by user for check in
				const checkInDate = flatpickr.formatDate(selectedDates[0], 'Y-m-d')

				// get date selected by user for check in
				const checkOutDate = selectedDates[1] ? flatpickr.formatDate(selectedDates[1], 'Y-m-d') : ''

				// validate same date selection
				if (checkOutDate === checkInDate) {
					createElementToast.fxCreateToastItem('danger', this.el.formContainer.dataset.toastCopyErrorSameDateSelection)
					// remove class focused - responsible for close modal after select any item
					document.querySelector('.searchbox__control-group--date').classList.remove('focused')
					return
				}
				// fill check in and check out fields
				this.el.inputCheckIn.value = checkInDate
				this.el.inputCheckOut.value = checkOutDate

				if (checkOutDate) {
					// first we find parent focused class and add updated class in order to hide label from container
					document.querySelector('.searchbox__control-group--date').classList.add('updated')

					// remove class focused - responsible for close modal after select any item
					document.querySelector('.searchbox__control-group--date').classList.remove('focused')
				}
			}
		}

		flatpickr(el, flatpickrOptions)
	},

	fxCheckClickEventOutSideSearchBox(event) {
		// save a variable if target of click event is inside any container - groupContainer
		const filterClick = [...this.el.groupContainer].filter(el => el.contains(event.target))

		// if none of containers have been clicked, we remove class focused on all search box
		filterClick.length === 0 && this.el.toggleModal.forEach(el => el.parentNode.classList.remove('focused'))
	},

	fxResetSearchBox() {
		this.el.formContainer.reset()
		// Remove class updated in all containers - responsible for show labels
		this.el.formContainer.querySelectorAll('.searchbox__control-group').forEach(el => el.classList.remove('updated'))

		// reset number of guests
		this.vars.currentNumberOfGuests = 0

		// reset counter value
		this.el.counterValue.textContent = 0

		// reset counter label
		this.el.counterLabelValue.value = ''

		// reset text default on select hostel list
		document.querySelector('.js-searchbox-select-value').textContent = 'Para onde vais?'
	},

	events() {
		// Responsible for close modals if user click outside container
		window.addEventListener('click', event => this.fxCheckClickEventOutSideSearchBox(event))

		// Responsible for toggle Modal on each input
		this.el.toggleModal.forEach(el => el.addEventListener('click', e => this.fxToggleModalSearchBox(e)))

		// Responsible for change counter value on input of guests quantity 
		this.el.counterButton.forEach(el => el.addEventListener('click', e => this.fxHandleCounter(e)))

		// Responsible to handle state of the promocode
		let input = document.getElementsByClassName('js-searchbox-promocode-value');
		if(input.length > 0){
			for (const eventName of ['click', 'focus', 'blur']) {
				this.el.promoValue.addEventListener(eventName, e => this.fxHandlePromoCode(e))
			}
		}

		// Responsible for switch tabs - Portugal or International
		this.el.tabs.forEach(el => el.addEventListener('click', e => this.fxSwitchTabs(e)))

		// Responsible for switch select list - Portugal or International
		this.el.tabs.forEach(el => el.addEventListener('click', e => this.fxSwitchSelectListOnceClicked(e)))

		// click event for selected item on select dropdown - Responsible for insert value to select form
		this.el.selectedItem.forEach(el => el.addEventListener('click', e => this.fxAddSelectValueToForm(e)))

		// Responsible for datepicker on Check in and Check out input
		this.el.flatPickerContainer.forEach(el => this.fxInitFlatpickr(el))
	},

	init() {
		this.events()
	}
}

serviceSearchBox.init()
